import * as React from "react";
const CostEfficiencySVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect width={48} height={48} x={4} y={4} fill="#fff" rx={24} />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#FDECEB"
      strokeWidth={8}
      rx={24}
    />
    <g clipPath="url(#a)">
      <path
        fill="#EE4137"
        d="M39.692 29.178a2.673 2.673 0 0 0-2.323-.462l-4.576 1.052A3.064 3.064 0 0 0 29.813 26h-5.476a3.48 3.48 0 0 0-2.475 1.025L19.388 29.5H16.25a1.75 1.75 0 0 0-1.75 1.75v4.375a1.75 1.75 0 0 0 1.75 1.75h11.375a.873.873 0 0 0 .212-.026l7-1.75a.763.763 0 0 0 .13-.044l4.252-1.81.048-.02a2.69 2.69 0 0 0 .43-4.547h-.005ZM16.25 31.25h2.625v4.375H16.25V31.25Zm22.25.898-4.156 1.77-6.828 1.707h-6.891v-4.888l2.475-2.474a1.735 1.735 0 0 1 1.237-.513h5.476a1.313 1.313 0 0 1 0 2.625H26.75a.875.875 0 1 0 0 1.75h3.5a.908.908 0 0 0 .196-.022l7.328-1.685.034-.01a.94.94 0 0 1 .689 1.74h.003Zm-6.063-7.898c.217 0 .433-.017.646-.052a3.937 3.937 0 1 0 3.086-5.141 3.937 3.937 0 1 0-3.731 5.193ZM39 22.937a2.187 2.187 0 1 1-4.375 0 2.187 2.187 0 0 1 4.375 0Zm-6.563-4.812a2.187 2.187 0 0 1 2.106 1.598 3.937 3.937 0 0 0-1.64 2.727 2.188 2.188 0 1 1-.465-4.325Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M14.5 13.75h28v28h-28z" />
      </clipPath>
    </defs>
  </svg>
);
export default CostEfficiencySVG;
